import React from 'react'
import { Link } from 'react-router-dom'
import Common from 'services/common'
import styles from './style.module.scss'

const DEFAULT_MESSAGE_ID = 'drift-cta-v1'
const DEFAULT_MESSAGE =
  "Models drift. Schemas drift. Baselines drift. Here's the one thing we don't let move"
const DEFAULT_CTA_TEXT = 'Read'
const DISMISS_KEY_PREFIX = 'toastDismissed_'
const DEFAULT_SIDEBAR_WIDTH = 256

class AnnouncementBanner extends React.Component {
  static defaultProps = {
    messageId: DEFAULT_MESSAGE_ID,
    message: DEFAULT_MESSAGE,
    ctaText: DEFAULT_CTA_TEXT,
    ctaTo: null,
    sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
    onHeightChange: () => {},
  }

  constructor(props) {
    super(props)
    this.bannerRef = React.createRef()
    this.state = {
      visible: !this.isDismissed(props.messageId),
    }
  }

  componentDidMount() {
    this.reportHeight()
  }

  reportHeight = () => {
    const height =
      this.state.visible && this.bannerRef.current ? this.bannerRef.current.offsetHeight : 0
    this.props.onHeightChange(height)
  }

  isDismissed = messageId => {
    try {
      return localStorage.getItem(DISMISS_KEY_PREFIX + messageId) === 'true'
    } catch (e) {
      return false
    }
  }

  handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY_PREFIX + this.props.messageId, 'true')
    } catch (e) {
      // localStorage unavailable (private mode, quota) — banner still hides for this render
    }
    this.setState({ visible: false }, this.reportHeight)
  }

  render() {
    const { message, ctaText, ctaTo } = this.props
    const { visible } = this.state
    if (!visible) {
      return null
    }
    const destination = ctaTo || Common.getPreURI() + '/home'
    const isExternal = /^https?:\/\//.test(destination)
    return (
      <div className={styles.banner} role="status" ref={this.bannerRef}>
        <span className={styles.message}>
          {message}{' '}
          {isExternal ? (
            <a
              className={styles.cta}
              href={destination}
              target="_blank"
              rel="noopener noreferrer"
              onClick={this.handleDismiss}
            >
              {'→ ' + ctaText}
            </a>
          ) : (
            <Link className={styles.cta} to={destination} onClick={this.handleDismiss}>
              {'→ ' + ctaText}
            </Link>
          )}
        </span>
        <button
          type="button"
          className={styles.dismissBtn}
          aria-label="Dismiss announcement"
          onClick={this.handleDismiss}
        >
          <i className="fal fa-times" aria-hidden="true" />
        </button>
      </div>
    )
  }
}

export default AnnouncementBanner
